import styled from '@emotion/styled'

export const S = {
  Container: styled.div<{ $fullscreen: boolean }>`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: ${({ theme }) => theme.eclipseTier1.spacing['12px']};
    padding: ${({ theme }) => theme.eclipseTier1.spacing['16px']};
    min-height: ${({ $fullscreen }) => ($fullscreen ? '100vh' : '40vh')};
    text-align: center;
    color: ${({ theme }) => theme.eclipseTier2Color.text.default};
  `,

  Title: styled.h1`
    margin: 0;
    ${({ theme }) => theme.eclipseTier2Typography.headingLg}
  `,

  Message: styled.p`
    margin: 0;
    color: ${({ theme }) => theme.eclipseTier2Color.text.subtlest};
  `,

  Actions: styled.div`
    display: flex;
    gap: ${({ theme }) => theme.eclipseTier1.spacing['8px']};
  `,

  Details: styled.details`
    max-width: 720px;
    width: 100%;
    text-align: left;
  `,

  Pre: styled.pre`
    border-radius: ${({ theme }) => theme.eclipseTier1.radius['8px']};
    padding: ${({ theme }) => theme.eclipseTier1.spacing['8px']};
    overflow: auto;
    font-size: ${({ theme }) => theme.eclipseTier2Typography.bodyMd.fontSize};
  `,
} as const
